import React, { useEffect, useState } from "react";
import Bowser from "bowser";
import "./classes/OldBrowserAlert.css";

function OldBrowserAlert() {
  const [showAlert, setShowAlert] = useState(false);
   
  useEffect(() => {
    const alreadyShown = localStorage.getItem("oldSafariWarningShown");
    const isLoginPage = window.location.pathname === "/user";

    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserName = browser.getBrowserName();
    const version = parseFloat(browser.getBrowserVersion());

    if (
      browserName &&
      browserName.includes("Safari") &&
      version < 16
    ) {
      // Login page - always show
    if (isLoginPage) {
      setShowAlert(true);
      return;
    }

    // Other pages - show only once
    if (!alreadyShown) {
      setShowAlert(true);
    }
    }
  }, []);
 const handleClose = () => {
    const isLoginPage = window.location.pathname === "/user";

  // Save only for non-login pages
  if (!isLoginPage) {
    localStorage.setItem("oldSafariWarningShown", "true");
  }
    setShowAlert(false);
  };
  if (!showAlert) return null;

  return (
    <div className="browser-warning-overlay">
      <div className="browser-warning-modal">
        
        <p>
          Having trouble? Your browser may be too old to load this page. Update your browser to continue or reach us at (503) 445-7105.
        </p>
        <button onClick={handleClose}>OK</button>
      </div>
    </div>
  );
}

export default OldBrowserAlert;